import FooterSection from "../../commponents/layout/Footer";
import AboutPreviewSection from "../../commponents/section/AboutPreviewSection";
import ClientSection from "../../commponents/section/QualityMaterials";
import ClientStorySection from "../../commponents/section/ClientStorySection";
import HeroHome from "../../commponents/section/HeroHome";
import OurClientSection from "../../commponents/section/OurClientSection";
import ProductCategorySection from "../../commponents/section/ProductCategorySection";
import RecentProjectSection from "../../commponents/section/RecentProjectSection";
import ServiceIndustry from "../../commponents/section/ServiceIndustry";
import { useHomePage } from "../../context/HomePageContext";

const PAGE_BACKGROUND =
  "min-h-screen bg-[linear-gradient(180deg,#5BA9AE_0%,#CFE9EA_30%,#EAF7F7_50%,#7CC2C6_75%,#3DA4A8_100%)]";

export default function Home() {
  const { status } = useHomePage();

  // Kunjungan pertama: tunggu konten dari admin sebentar (maks ~6 detik),
  // supaya pengunjung tidak melihat konten bawaan lalu berganti.
  if (status === "loading") {
    return (
      <main
        aria-busy="true"
        className={`${PAGE_BACKGROUND} flex items-center justify-center`}>
        <div
          role="status"
          aria-label="Loading"
          className="h-12 w-12 animate-spin rounded-full border-4 border-white/40 border-t-white"
        />
      </main>
    );
  }

  return (
    <>
      <main className={PAGE_BACKGROUND}>
        <HeroHome />
        <ProductCategorySection />
        <AboutPreviewSection />
        <RecentProjectSection />
        <ClientSection />
        <ServiceIndustry />
        <OurClientSection />
        <ClientStorySection />
        <FooterSection />
      </main>
    </>
  );
}
